import type { FC } from 'react';

import { Logo } from '../../../../components/Logo';
import type { LogoSize } from '../../../../components/Logo/styled';
import { useSportsRedirect } from '../../hooks/useSportsRedirect';

interface ISportsLogoProps {
  logoSize?: LogoSize;
}

export const SportsLogo: FC<ISportsLogoProps> = ({ logoSize }) => {
  const href = useSportsRedirect();

  return <Logo href={href} logoSize={logoSize} />;
};
